import { toast } from 'react-toastify';

const COMMON_SETTINGS = {
  position: 'bottom-right',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
};

const renderMessage = {
  patchToDay: data => ({
    success: `Successfully ${
      data.editType === 'remove'
        ? `removed ${data.theme} from your trek!`
        : data.editType === 'add'
        ? `added ${data.theme} to your trek!`
        : 'edited'
    }`,
    error: `Error trying to ${data.editType} ${
      data.theme
    } from your trek. Please try again!`,
  }),
  requestToBookLodge: data => ({
    success: `Successfully requested booking of ${data.lodgeName} at ${data.lodgeAddress}`,
    error: `Error trying to book ${data.lodgeName} at ${
      data.lodgeAddress
    }. Please try again!`,
  }),
  lodgePayment: data => ({
    success: `Successfully requested payment for ${data.lodgeName} at ${data.lodgeAddress}`,
    error: `Error requesting payment for ${data.lodgeName} at ${data.lodgeAddress}`,
  }),
  trekPayment: data => ({
    success: `Successfully requested payment for trek ${data.trekName}`,
    error: `Error requesting payment for trek ${data.trekName}`,
  }),
  getUserProfile: () => ({
    // success: 'Successfully fetched profiie',
    error: 'Error trying to fetch your profile data',
  }),
  editProfile: () => ({
    success: 'Successfully edited field',
    error: 'Error trying to edit field. Please try again!',
  }),
  useAsTemplate: () => ({
    success: 'Successfully created a trek.',
    error: 'Error trying to create a new trek. Please try again!',
  }),
  changeTrekNameDate: data => ({
    success: `Successfully changed ${data.trekDate ? 'name and date' : 'name'} of trek!`,
    error: `Error trying to change ${
      data.trekDate ? 'name and date' : 'name'
    } of trek. Please try again!`,
  }),
  changeTrekHighlights: () => ({
    success: 'Successfully edited highlights of the trek',
    error: 'Got an error trying to edit highlights of the trek. Please try again!',
  }),
  changeTrekBasicInfo: () => ({
    success: 'Successfully edited Group Size of the trek',
    error: 'Got an error trying to edit group size of the trek. Please try again!',
  }),
  changeTrekPrice: () => ({
    success: 'Successfully edited Price of the trek',
    error: 'Got an error trying to edit price of the trek. Please try again!',
  }),
  changeTrekDescription: () => ({
    success: 'Successfully edited descriptions of the trek',
    error: 'Got an error trying to edit descriptions of the trek. Please try again!',
  }),
  updateTrekPreferences: () => ({
    // success: 'Successfully updated preferences of the trek',
    error: 'Got an error trying to update trek preference. Please try again!',
  }),
  saveTrekPreferences: () => ({
    success: 'Successfully saved trek preferences',
    error: 'Got an error trying to save trek preferences. Please try again!',
  }),
  dateChangeOnTrekBuy: () => ({
    success: 'Successfully changed trek date!',
    error: 'Got an error trying to change trek date. Please try again!',
  }),
  editQuickFacts: () => ({
    success: 'Successfully edited quick facts of trek!',
    error: 'Got an error trying to edit quick facts of trek. Please try again!',
  }),
  freezeTrek: data => ({
    success: `Successfully ${data.is_frozen ? 'freezed' : 'unfreezed'} trek!`,
    error: `Got an error trying to ${
      data.is_frozen ? 'freeze' : 'unfreeze'
    } trek. Please try again!`,
  }),
  profileImage: () => ({
    error: 'Error',
  }),
};

const toastType = {
  error: message =>
    toast.error(message, {
      ...COMMON_SETTINGS,
    }),
  success: message =>
    toast.success(message, {
      ...COMMON_SETTINGS,
    }),
};

function getToast({ type, status, data }) {
  return renderMessage[type] ? toastType[status](renderMessage[type](data)[status]) : null;
}

export async function apiWithToast({ api, type, data, byPassCondition, throwError }) {
  try {
    const response = await api();
    if (byPassCondition !== 'success') getToast({ type, status: 'success', data });
    return response;
  } catch (err) {
    if (byPassCondition !== 'error') getToast({ type, status: 'error', data });
    if (throwError) throw new Error('Fetch error');
  }
}

export function getToastMsg({ status, type, data }) {
  return renderMessage[type] ? getToast({ type, status, data }) : null;
}

export function getCustomToast(message, status) {
  return toastType[status](message);
}



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/Toast.js